import { Auth } from 'aws-amplify';

export const fetchAPI = async ({ url, method, header, data }, retries = 3) => {
  try {
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json', ...header },
      method: method,
      body: JSON.stringify(data),
    });

    if (res.ok) {
      return await res.json();
    }

    if (res.status === 401 && retries > 0) {
      const session = await Auth.currentSession();
      const { idToken } = session;

      return fetchAPI(
        {
          url,
          method,
          header: {
            Authorization: `Bearer ${idToken.jwtToken}`,
          },
          data,
        },
        retries - 1,
      );
    }

    if (res.status === 401 && retries === 0) {
      await Auth.signOut();
      localStorage.clear();
      window.location.reload();
    }
  } catch (err) {
    throw new Error(err.message);
  }
};
